import { defineMessages } from '@redbubble/next/intl';

export const messages = defineMessages({
  byArtist: {
    defaultMessage: 'By {artistName}',
  },
  addedToCart: {
    defaultMessage: 'Added to Cart',
  },
  previewAltText: {
    defaultMessage: 'Item preview, {title} designed and sold by {artistName}.',
  },
  previewAltTextFallback: {
    defaultMessage: 'Item preview.',
  },
  establishedArtist: {
    defaultMessage: 'Established artist',
  },
});
